import React from "react";
import { withSiteData } from "react-static";
//
import Header from "components/menu";
//
export default withSiteData(({ menu }) => <Header {...menu} />);
